<template>
  <div>
    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          :disabled="acceptFormattingDisabled"
          class="success mr-1"
          fab
          x-small
          v-on="{ ...tooltip }"
          @click="acceptFormatting()"
        >
          <v-icon>mdi-account-search</v-icon>
        </v-btn>
      </template>
      <span>ACCEPT FORMATTING</span>
    </v-tooltip> -->

    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-hover v-slot="{ hover }">
          <v-btn
            block
            height="80"
            class="success mr-1"
            :elevation="hover ? 8 : 2"
            v-on="{ ...tooltip }"
            :disabled="acceptFormattingDisabled"
            @click="acceptFormatting()"
          >
            <div class="d-flex flex-column align-center">
              <v-icon>mdi-account-search</v-icon>
              <span class="action-text">ACCEPT FORMATTING</span>
            </div>
          </v-btn>
        </v-hover>
      </template>
      <span>ACCEPT FORMATTING</span>
    </v-tooltip>

    <!-- THE DIALOG BEGINS HERE -->
    <v-dialog persistent v-model="dialogAcceptFormatting" max-width="750px">
      <v-card>
        <v-card-title class="justify-center text-h5 grey lighten-2">
          <span class="text-h5">ACCEPT FORMATTING</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-card width="100%" class="mt-3 mb-3 text-start">
                <v-card-title>I ACCEPT</v-card-title>
                <!-- <v-list subheader two-line flat dense>
                  <v-subheader class="text-h6">I agree:</v-subheader>

                  <v-list-item-group multiple>
                    <v-list-item>
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            color="primary"
                            v-model="checkboxAcceptFormatting"
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>Formatting</v-list-item-title>
                          <v-list-item-subtitle
                            >I accept to format the
                            report.</v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            color="primary"
                            v-model="checkboxAcceptFormatting1"
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>Documents</v-list-item-title>
                          <v-list-item-subtitle
                            >I will maintain document
                            privacy.</v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-list> -->
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    tile
                    dark
                    small
                    @click="closeAcceptFormattingDialog"
                    class="mt-3 mr-2 error"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    tile
                    small
                    class="mt-3 success"
                    @click="compAcceptFormatting"
                    >Submit</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CasefileDataService from "../../services/CasefileDataService";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "acceptFormatting",
  props: [],
  components: {},

  data() {
    return {
      dialogAcceptFormatting: false,
      // checkboxAcceptFormatting: false,
      // checkboxAcceptFormatting1: false,
    };
  },

  computed: {
    acceptFormattingDisabled() {
      return !(
        this.caseState.casefile.fileStatus == `CLERK` &&
        this.caseState.casefile.clerkInCharge == this.$store.state.auth.user.id
      );
    },

    ...mapState(["caseState"]),

    // isFileButtonDisabled() {
    //   return !(this.checkboxAcceptFormatting && this.checkboxAcceptFormatting1);
    // },
  },
  watch: {
    acceptFormatting(val) {
      val || this.closeAcceptFormattingDialog();
    },
  },

  methods: {
    // moment: function (date) {
    //   return moment(date);
    // },
    acceptFormatting() {
      this.dialogAcceptFormatting = true;
    },

    compAcceptFormatting() {
      CasefileDataService.update(
        this.caseState.casefile.id,
        this.caseState.casefile,
        (this.caseState.casefile.fileStatus = `FOIN`),
        (this.caseState.casefile.dateStartFormatting = moment().format())
      )
        .then((response) => {
          this.closeAcceptFormattingDialog();
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "warning",
            text:
              (response && response.data && response.data.message) ||
              toString(),
          });
        })
        .catch((e) => {
          console.log(e);
        });

      this.closeAcceptFormattingDialog();
    },

    closeAcceptFormattingDialog() {
      this.dialogAcceptFormatting = false;
      this.$nextTick(() => {});
    },
  },
};
</script>
